// import {getLeaderBoardPageSize} from "../../helpers/Helpers";

const initialState = {
    leadersHead: null,
    leadersTail: null,
    loading: false,
    currentUser: null,
    lastPage: false,
    filter: null,
    showLoadBetween: true
};

export default (state = initialState, action) => {
    const {type, payload} = action;

    let leadersHead = [];
    let leadersTail = [];

    let headLast = null;
    let tailFirst = null;
    let showLoadBetween = true;
    let lastItemLoaded = true;
    let lastItemsOrderRow = null;

    switch (type) {

        case "LEADER_BOARD_RESET":
            return initialState;

        case "LEADER_BOARD_SET_GROUP_BY":
            return {
                ...state,
                filter: {
                    ...state.filter,
                    groupBy: payload
                }
            }

        case 'LEADER_BOARD_SET_FILTER':
            return {
                ...state,
                filter: payload
            };

        case 'LEADER_BOARD_LOADING_TOP':
            //initial load so lets clear existing items
            return {
                ...state,
                loading: true,
                leadersHead: null,
                leadersTail: null,
                currentUser: null,
                lastPage: false,
                showLoadBetween: true
            };

        case 'LEADER_BOARD_LOADING_LOADMORE':
            return {
                ...state,
                loading: true,
            };

        case 'LEADER_BOARD_GET_TOP_SUCCESS':
            let {usersPointsList, currentUser, currentUserItem, itemList, rowsCount} = payload;

            if (!currentUser && currentUserItem) {
                currentUser = currentUserItem;
            }
            if (!usersPointsList && itemList) {
                usersPointsList = itemList;
            }

            leadersHead = [];
            leadersTail = [];

            if (usersPointsList) {
                for (let x in usersPointsList) {
                    if (currentUser) {
                        if (usersPointsList[x].orderRow < currentUser.orderRow) {
                            leadersHead.push(usersPointsList[x]);
                        } else {
                            leadersTail.push(usersPointsList[x]);
                        }
                    } else {
                        leadersTail.push(usersPointsList[x]);
                    }
                    lastItemsOrderRow = usersPointsList[x].orderRow;
                }
            }

            headLast = (leadersHead && leadersHead.length > 0) ? leadersHead[(leadersHead.length - 1)] : null;
            tailFirst = (leadersTail && leadersTail.length > 0) ? leadersTail[0] : null;
            showLoadBetween = (headLast && tailFirst) ? ((headLast.orderRow + 1) !== (tailFirst.orderRow)) : false;
            lastItemLoaded = lastItemsOrderRow ? lastItemsOrderRow === rowsCount : true;
            if (lastItemLoaded) {
                if (leadersHead.length + leadersTail.length < rowsCount) {
                    showLoadBetween = true;
                }
            }

            return {
                ...state,
                loading: false,
                leadersHead: leadersHead,
                leadersTail: leadersTail,
                currentUser: (currentUser ? currentUser : currentUserItem),
                lastPage: lastItemLoaded,
                showLoadBetween: showLoadBetween
            };

        case 'LEADER_BOARD_GET_LOADMORE_SUCCESS':

            leadersHead = state.leadersHead;
            leadersTail = state.leadersTail;
            rowsCount = payload.rowsCount;

            if (payload.usersPointsList) {
                for (let x in payload.usersPointsList) {
                    if (payload.currentUser && payload.usersPointsList[x].orderRow === payload.currentUser.orderRow) {
                        //skiping same item...
                    } else {
                        if (!payload.currentUser || payload.usersPointsList[x].orderRow < payload.currentUser.orderRow) {
                            leadersHead.push(payload.usersPointsList[x]);
                        } else {
                            leadersTail.push(payload.usersPointsList[x]);
                        }
                    }

                    lastItemsOrderRow = payload.usersPointsList[x].orderRow;
                }
            }

            if (payload.itemList) {
                for (let x in payload.itemList) {
                    if (payload.currentUserItem && payload.itemList[x].orderRow === payload.currentUserItem.orderRow) {

                    } else {
                        if (!payload.currentUserItem || payload.itemList[x].orderRow < payload.currentUserItem.orderRow) {
                            leadersHead.push(payload.itemList[x]);
                        } else {
                            leadersTail.push(payload.itemList[x]);
                        }
                    }
                    lastItemsOrderRow = payload.itemList[x].orderRow;
                }
            }

            if (leadersTail && leadersTail.length > 0) {
                lastItemsOrderRow =leadersTail[leadersTail.length-1].orderRow;
            } else {
                if (leadersHead && leadersHead.length>0){
                    lastItemsOrderRow =leadersHead[leadersHead.length-1].orderRow;
                }
            }


            headLast = (leadersHead && leadersHead.length > 0) ? leadersHead[(leadersHead.length - 1)] : null;
            tailFirst = (leadersTail && leadersTail.length > 0) ? leadersTail[0] : null;
            showLoadBetween = (headLast && tailFirst) ? ((headLast.orderRow + 1) !== (tailFirst.orderRow)) : false;
            lastItemLoaded = lastItemsOrderRow ? lastItemsOrderRow === rowsCount : true;

            return {
                ...state,
                loading: false,
                leadersHead: leadersHead,
                leadersTail: leadersTail,
                currentUser: (payload.currentUser ? payload.currentUser : payload.currentUserItem),
                lastPage: lastItemLoaded,
                showLoadBetween: showLoadBetween
            };

        case 'LEADER_BOARD_GET_LOADMORE_FAILURE':
        case 'LEADER_BOARD_GET_TOP_FAILURE':
            return {
                ...state,
                loading: false
            };

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/store/reducers/leaderBoard.js